import { Injectable, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
//import { StorageService } from '../../../comum/services/storage.service';
import { Router } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { Subscription } from 'rxjs';

import { Publicidades, IPublicidades } from '../../../models/publicidades.model';
import { Produtos, IProdutos } from '../../../models/produtos.model';
import { Splash, ISplash } from '../../../models/splash.model';
import { ICategorias } from '../../../models/categorias.model';
import { CarrinhoModel, ICarrinho } from '../../../models/carrinho.model';

import { Favoritos, IFavoritos } from '../../../models/favoritos.model';

import { getTableNameFull } from '../../../models/data.model';
import { TextSearch } from '../../../comum/textSearch';
import { environment } from '../../environments/environment';
import { Localidades, ILocalidades } from '../../../models/localidades.model';

import { DivulgacaoFornecedor } from '../../../models/divulgacao.model';
import { UsersService } from '../../../models/usuarios.service';
import { Http } from '@angular/http';


@Injectable()
export class DadosService implements OnDestroy {

  connection;

  localidade = null;
  localidadesClass: Localidades;
  localidades: ILocalidades[] = [];
  localidadesEvent: Subscription;

  publicidadesClass: Publicidades;
  publicidades: IPublicidades[] = [];
  publicidadeEvent: Subscription;

  produtosClass: Produtos;
  produtos: IProdutos[] = [];
  produtosEvent: Subscription;

  produtosCategClass: Produtos;
  produtosCateg: IProdutos[] = [];
  produtosCategEvent: Subscription;


  splashClass: Splash;
  splashEvent: Subscription;


  nomeLoja: string = environment.site.nome;
  pathLogos: string = "./assets/img-logos/";
  local: string = 'Atibaia/SP';
  @Output() change = new EventEmitter();

  fornecedorCorrente: number = 0;
  grupoCorrente: number = 0;
  favoritos: any = [];
  ultimaEntrega = null;
  mensagensRodape = [''];

  pedidos: any[] = [];

  config: any = {
    icons: {
      pedido: 'receipt',
      mensagem: 'message'
    },
    splash: []
  }

  meiosPagamento: any = [];
  //dadosProdutos: any = [];
  dadosProdutosMaster: any = [];
  dadosCategorias: any = [];
  dadosFornecedores: any = [];
  dadosFornecedoresMaster: any = [];
  carrinho: CarrinhoModel;
  carrinhoItems = [];
  carrinhoEvent:Subscription;


  @Input() get total() {
    return this.carrinho.total;
  }
  @Input() get entrega() {
    return this.carrinho.entrega;
  }
  set entrega(x) {
    this.carrinho.entrega = x;
    this.salvar();
  }

  private stCarrinho: string;

  constructor(
    private router: Router,
    private db: AngularFirestore,
    private http: Http,
    private users: UsersService) {
    this.connection = db;
    this.carrinho = new CarrinhoModel(db,http);
    this.carrinhoEvent = this.carrinho.eventChange.subscribe(
       _carrinho=>{
         this.carrinhoItems = _carrinho.items;
       }
    )
    this.carrinho.restore();
    this.stCarrinho = this.carrinho.stCarrinho;

    let x = window.localStorage.getItem(getTableNameFull('UltimaEntrega'));
    try {
      //console.log(x);
      if (x != null)
        this.ultimaEntrega = JSON.parse(x);
    } catch (err) {
      this.ultimaEntrega = null;
      this.errorLog('dadosService','localStorage',err);
    }
    this.Init();

  }

  ngOnDestroy(): void {
    //console.log('onDestroy')
    if (this.carrinhoEvent) this.carrinhoEvent.unsubscribe();
    if (this.publicidadeEvent) this.publicidadeEvent.unsubscribe();
    if (this.produtosEvent) this.produtosEvent.unsubscribe();
    if (this.splashEvent) this.splashEvent.unsubscribe();
    if (this.localidadesEvent) this.localidadesEvent.unsubscribe();
  }

  Init() {
    // buscar publicidades
    this.publicidadesClass = new Publicidades(this.db);
    this.publicidadeEvent = this.publicidadesClass.changedEvent.subscribe(
      d => {
        this.publicidades = d;
      }
    );
    this.publicidadesClass.verInativo = false;

    // buscar produtos
    this.produtosClass = new Produtos(this.db,0,false);
    this.produtosEvent = this.produtosClass.changedEvent.subscribe(
      d => {
        // console.log('produtos',d);
        this.produtos = d.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
      }
    )
    this.produtosClass.verInativo = false;

    this.splashClass = new Splash(this.db);
    this.splashEvent = this.splashClass.changedEvent.subscribe(
      d => {
        this.config.splash = d;
      }
    )
    this.splashClass.verInativo = false;


    this.db.collection(getTableNameFull('categorias'), r => {
      return r.where("inativo", "==", false);
    }).valueChanges()
      .subscribe(d => {
        this.dadosCategorias = d.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
      });

    this.localidadesClass = new Localidades(this.db);
    this.localidadesEvent = this.localidadesClass.changedEvent.subscribe(
      d => { this.localidades = d; }
    );
    this.localidadesClass.verInativo = false;

    this.db.collection(getTableNameFull('fornecedores'),
      r => { return r.where("mostrarMenu", '==', true).where('inativo','==',false) }).valueChanges()
      .subscribe(
        d => {
          this.dadosFornecedores = d.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
        }
      )
    this.db.collection(getTableNameFull('fornecedores'),
      r => { return r.where('mostrarMaster', '==', true).where('inativo','==',false) }).valueChanges()
      .subscribe(d => {
        this.dadosFornecedoresMaster = d.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
      });
    this.db.collection(getTableNameFull('meiosPagamento'),
        r=>{
          return r.where('inativo','==',false)
        }).valueChanges()
      .subscribe(d => {
        this.meiosPagamento = d.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
      })
  }
  get localidadeNome() {
    return window.localStorage.getItem(getTableNameFull("localidade"));
  }
  set localidadeNome(x) {
    window.localStorage.setItem(getTableNameFull("localidade"), x);
  }

  goto(rota) {
    this.router.navigate([rota]);
  }

  getCurrentDir() {
    return window.location.href;
  }

  salvar() {
    this.change.emit(this.total);
    this.carrinho.user = this.users.usuario;
    this.carrinho.salvar();
  }

  getProdutos(fornec: number, pSubscribe) {
    const prod = new Produtos(this.db,0,false);
    prod.snapshot(r => {
      return r.where("fornecedor", "==", fornec)
        .where("inativo", "==", false);
    }, d => {
      this.produtos = d;
      if (pSubscribe) pSubscribe(d);
      return d;
    }
    )
  }


  getProdutosCateg(grupo, pSubscribe) {
    //console.log("produtoCategoria", grupo);
    if (!this.produtosCategClass) {
      this.produtosCategClass = new Produtos(this.db,0,false);
    }
    this.produtosCategClass.snapshot(r => {
      return r.where("categoria", "==", Number(grupo))
        .where("inativo", '==', false);
    }, d => {
      this.produtosCateg = d;
      this.produtos = d;
      //console.log(d);
      if (pSubscribe) {
        pSubscribe(d);
      }
      return d;
    });
  }

  errorLog(app, ident, erro) {
    try {
      if (this.users.logado)
        erro['user'] = this.users.usuario;
      console.log(erro);
      this.db.collection('erros').doc(app).collection(ident).add(erro);
    } catch (err) {
      // nao faz nada
    }
  }

  getCategorias() {
    return this.dadosCategorias;
  }

  getFornecedores() {
    return this.dadosFornecedores;
  }

  getFornecedoresMaster() {
    return this.dadosFornecedoresMaster;
  }

  getProdutosMaster() {
    var rt = [];
    this.dadosProdutosMaster.forEach(m => {
      this.produtos.forEach(prod => {
        if ((m.fornecedor == prod.fornecedor)
          &&
          (m.codigo == prod.codigo)) {
          rt.push(prod);
        }
      })
    })
    return rt;
  }

  getFornecedor(codigo: number) {
    var rt = {};
    this.dadosFornecedores.forEach(element => {
      if (element.codigo == codigo) {
        rt = element;
        return rt;
      }
    });
    return rt;
  }

  getProduto(fornec: number, codigo): any {
    var rt;
    //console.log(this.produtos);
    this.produtos.forEach(element => {
      if ((element.fornecedor == fornec) &&
        (element.codigo == codigo)) {
        rt = element;
        return rt;
      }
    });
    return rt;
  }


  getPrecoVenda(fornec: number, codigo) {
    let rt = 0;
    let item = this.getProduto(fornec, codigo);
    if (item.codigo != null) {
      rt = item.precoVenda;
    }
    return rt;
  }

  addItem(fornec: number, produto, qtde, preco, fornAttrib?) {
    if (!fornAttrib)
      fornAttrib = this.getFornecedor(fornec);
    //console.log(fornAttrib);
    var item: any = this.getProduto(fornec, produto);
    //console.log(item);
    if (item)
      this.carrinho.addItem(fornec, produto, qtde, preco, item, fornAttrib)
    else {
      // nao esta carregado na memoria, carregar.
      const p = new Produtos(this.db,0,false);
      p.snapshot(
        r => {
          return r.where("fornecedor", '==', fornec)
            .where("codigo", "==", produto);
        }, d => {
          if (d[0].codigo == produto) {
            this.carrinho.addItem(fornec, produto, qtde, preco, d[0], fornAttrib)
            this.produtos.push(d[0]);
          }
        }
      )
    }
  }

  getCount() {
    return this.carrinho.items.length;
  }

  deleteItem(idx) {
    this.regAnalytics(this.carrinho.items[idx].fornecedor, 'acessos', 'excluirItem', 1);
    this.carrinho.deleteItem(idx);
  }

  clear() {
    this.carrinho.clear();
  }

  somar() {
    return this.carrinho.somar();
  }

  confirmarPedido(proc) {
    this.carrinho.user = this.users.usuario;
    try {
    this.carrinho.confirmarPedido(
      conf => {
       try {
        this.meusPedidos();
        this.pedidos.unshift(conf);
        this.salvarPedidos();
        window.localStorage.setItem(getTableNameFull('UltimaEntrega'), JSON.stringify(conf.entrega));
        this.ultimaEntrega = conf.entrega;
       } catch(err){
         console.log(err.message);
       } 
        proc(conf);
      }
    )
  } catch( err){
    console.log(err.message);
  };
  }

  setFavorito(codigo, valor) {
    let dbFav = new Favoritos(this.db);
    dbFav.user = this.users.usuario;
    dbFav.addFavorito(this.fornecedorCorrente, codigo, valor);
    this.favoritos.push({ codigo: codigo, valor: valor });
  }

  getLogo(arq) {
    return this.pathLogos + arq;
  }

  getPublicidade(pagina, proc?) {
    var rt = [];
    this.publicidades.forEach(elem => {
      if (elem.pagina == pagina)
        rt.push(elem);
      if (proc) proc(rt);
    })
    return rt;
  }

  /* metodos de pedidos */
  meusPedidos() {
    if (this.pedidos == null)
      this.carregarPedidos();
    return this.pedidos;
  }
  meusPedidosLimpar() {
    this.pedidos = [];
    window.localStorage.removeItem(getTableNameFull('Pedidos'));
  }

  carregarPedidos() {
    let p = window.localStorage.getItem(getTableNameFull('Pedidos')) ;
    if (!p) p = '[]';
    this.pedidos = JSON.parse( p );
    if (this.pedidos == null) {
      this.pedidos = [];
    }
  }
  salvarPedidos() {
    if (this.pedidos != null)
    window.localStorage.setItem(getTableNameFull('Pedidos'), JSON.stringify( this.pedidos));
  }

  getProcurarProdutoPor(text: string, pSubscribe?: any): any {
    var ref = this.db.collection(getTableNameFull('produtos'),
    ).ref;
    var query = TextSearch.encodeWhere(ref, 'search.', text);
    query.onSnapshot(docs => {
      let arr = [];
      docs.forEach(element => {
        arr.push({ id: element.id, ...element.data() });
      }, erro => {
        this.errorLog('dadosService','getProcurarProdutoPor',erro);
      });
      pSubscribe(arr);
    });
  }

  regAnalytics(fornecedor, ident, pagina, gostou) {
   try{ 
    let tmp = new DivulgacaoFornecedor(this.db);
    tmp.user = this.users.usuario;
    tmp.addAnalytics(fornecedor, ident, pagina, gostou);
   } catch(err){
     this.errorLog('dadosService','analytics',err);
   } 
  }

}
